import FeatureHighlightsBackground from 'assets/FeatureHighlightsBackground.png';
import ErrorIcon from 'assets/error-icon.svg';
import ExitWarning from 'assets/exit-warning.svg';
import DefaultProfileImage from 'assets/default-profile-image.svg';
import EmptyState from 'assets/empty-state-activites.svg';
import EmptyProgress from 'assets/empty-progress.svg';
import RemoveProgramWarningImage from 'assets/remove-warning.svg';

const ONBOARDING_OVERRIDES = {
  FEATURE_HIGHLIGHT_BACKGROUND: FeatureHighlightsBackground,
};

const COMMON_OVERRIDES = {
  WEB_COMMON_ERROR_STATE_IMAGE: ErrorIcon,
};

const JOURNEY_ASSETS = {
  EMPTY_STATE_HISTORY: EmptyState,
  EMPTY_STATE_ACHIEVEMENTS: EmptyProgress,
  WAVE_GOODBYE: ExitWarning,
  REMOVE_ACTIVITY_IMAGE: RemoveProgramWarningImage,
};

export const ASSET_OVERRIDES = {
  ERROR_STATE_COVER: ErrorIcon,
  ABOUT_ME_PROFILE_AVATAR: DefaultProfileImage,
  REMOVE_PROGRAM_IMAGE: RemoveProgramWarningImage,
  ...ONBOARDING_OVERRIDES,
  ...COMMON_OVERRIDES,
  ...JOURNEY_ASSETS,
};
